import dateTimeHelper from "../../../Helpers/datetimeHelper";

export default class RepeatLineItemData
{
	constructor(item) 
	{
		    this.FreelancerLineItemId = item.FreelancerLineItemId;
            this.StartDate=dateTimeHelper.firstDayOfTheNextMonth();
            this.EndDate=this.StartDate;
            this.PeriodMonth=1;
	}

}